module.exports = __webpack_public_path__ + "static/high-proficiency-45bbe8bf7cb6049e5418d97a3d3e54a2.jpg";